'use strict';

class SyncDialogCtrl {

    constructor($scope, $mdDialog, $http ) {

        //Attach dependicies to class root
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$http = $http;

        $scope.sendingDataToServer = false;
        $scope.receivedDataFromServer = null;
        $scope.repeat_request = {};

        $scope.cancel = () => {

            this.$mdDialog.cancel();
        };

        $scope.ok = () => {

            this.$mdDialog.hide();
        };

        $scope.sync = () => {

            $scope.sendingDataToServer = true;

            this.$http.post('/sync', $scope.repeat_request).then((response) => {

                $scope.sendingDataToServer = false;
                $scope.receivedDataFromServer = response.data;

            });
        };
    }
}

/*
 * Minify protecion depedencies
 */
SyncDialogCtrl.$inject = [
    '$scope',
    '$mdDialog',
    '$http'
];


/*
 * Browsify connection: execute controller
 */
module.exports = SyncDialogCtrl;